import { http } from "./http";
import type {
  FeedObj,
  FeedObjDTO,
  MapFeedDTO,
  MapFeedItemDTO,
  VenueDetailDTO,
} from "../data/types";



export async function fetchFeed(): Promise<FeedObj[]> {
  const dto = await http.get<FeedObjDTO[]>("/feed");

  return dto.map((item) => ({
    ...item,
    time: new Date(item.time),
  })) as FeedObj[];
}

export async function fetchMapFeed(params?: { limit?: number; minVenues?: number }) {
  const qs = new URLSearchParams();
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.minVenues) qs.set("minVenues", String(params.minVenues));

  const path = qs.toString() ? `/mapfeed?${qs}` : "/mapfeed";
  return await http.get<MapFeedDTO>(path);
}

/**
 * Ett ställe, oavsett om kartan visar det just nu. 404 betyder att stället
 * inte finns — se GET /venues/:id i api/routes.js.
 */
export async function fetchVenue(venueId: string): Promise<MapFeedItemDTO> {
  const res = await http.get<VenueDetailDTO>(`/venues/${encodeURIComponent(venueId)}`);
  return res.item;
}

/**
 * Gillningar. Servern svarar med det färska antalet, så klienten aldrig
 * behöver räkna själv — den som klickat snabbt två gånger rättas av nästa
 * svar i stället för att driva iväg.
 */
export type LikeResponse = { ok: boolean; liked: boolean; likes: number };

export async function likePost(postId: string) {
  return await http.post<LikeResponse>(`/posts/${postId}/like`, {});
}

export async function unlikePost(postId: string) {
  return await http.delete<LikeResponse>(`/posts/${postId}/like`);
}
